import React from 'react';
export function MainContent() {
  return <main className="bg-white border border-gray-300 p-6" data-id="element-49">
      <h2 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-50">
        USA Bearings and Belts
      </h2>

      <div className="space-y-4 text-gray-700" data-id="element-51">
        <p className="text-center font-semibold" data-id="element-52">
          UPS and USPS shipments are being delayed. UPS is not guaranteeing any
          type of shipment
        </p>

        <p className="text-center" data-id="element-53">
          We are taking care of our employees and practicing the, "One Life
          Matters" philosophy. Safety measures are in place and may
          inconvenience some.
        </p>

        <p className="text-center" data-id="element-54">
          We are monitoring email or you may call during normal business hours.
        </p>

        <p className="text-center" data-id="element-55">
          We are the Largest <strong data-id="element-56">Stocking</strong> distributor in West Coast
          of Florida with multiple shipping locations through out the USA.
        </p>

        <p className="text-center" data-id="element-57">
          We are proud to sell{' '}
          <strong data-id="element-58">
            Nachi, FAG, SKF, ORS, Moline, ZKL, USBB Opti Belt, Kevlar Belts,
            USBB
          </strong>{' '}
          and other major brands.
        </p>

        <div className="border-t border-b border-gray-300 py-4 my-4" data-id="element-59">
          <p className="text-center" data-id="element-60">
            <strong data-id="element-61">
              We carry all types of bearings and industrial products,
            </strong>{' '}
            Shafting, Roller Chain, Sprockets, Pillow Block Bearings, 2 Bolt
            Flange Units, 4 Bolt Flange Units, Stainless Steel Ball Bearings,
            Stainless Steel & Thermoplastic Mounted Units, Taper Roller
            Bearings, Single & Double Row Bearings, Insert Bearings and much
            much more.
            <strong data-id="element-62">
              {' '}
              Moline Mounted Units are Manufactured in the USA! We can supply
              you with "Great Bearings" and value for your dollar.
            </strong>
          </p>
        </div>

        <p className="text-center" data-id="element-63">
          If you don't see what you are looking for check our site map with
          model charts or please e-mail us or call one of our knowledgeable
          staff members to assist you with your request.
        </p>

        <p className="text-center" data-id="element-64">
          Check our <strong data-id="element-65">Bulk Sales</strong>, The Bulk sales are all{' '}
          <span className="text-red-600 font-bold" data-id="element-66">Free Shipping.</span>
        </p>

        <div className="flex justify-center mt-6" data-id="element-67">
          <a href="#" className="inline-flex items-center gap-2 bg-blue-600 text-white px-6 py-3 font-semibold hover:bg-blue-700" data-id="element-68">
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-69">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-70" />
            </svg>
            Find us on Facebook
          </a>
        </div>
      </div>
    </main>;
}